"use client";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Download from "yet-another-react-lightbox/plugins/download";

import "yet-another-react-lightbox/styles.css";

import { useMemo } from "react";

interface ImagesViewerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  images?: string[] | null;
}

export function ImagesViewer({
  isOpen,
  onOpenChange,
  images,
}: ImagesViewerProps) {

  // ---------------- Slides convert từ props ----------------
  const slides = useMemo(() => {
    if (!!images?.length) {
      return images.map(url => ({ src: url }));
    }

    return [];
  }, [images]);

  // ---------------- Lắng event từ iframe để gọi download thực ----------------

  if (!images?.length) return null;
  if (!slides.length) return null;

  return (
    <Lightbox
      open={isOpen}
      close={() => onOpenChange(false)}
      slides={slides as any}
      carousel={{ finite: false, preload: 0 }}
      plugins={[Zoom, Captions, Download, Fullscreen]}
    />
  );
}
